<script setup>
import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'
import OverviewFeedItem from './OverviewFeedItem.vue'

const page     = usePage()
const activity = computed(() => page.props.__neo_main?.__data?.activity ?? [])
</script>

<template>
    <div>
        <div v-if="!activity.length" class="text-[13px] text-gray-400 dark:text-neutral-500 py-3">{{ $t('dashboard.activity_empty') }}</div>
        <OverviewFeedItem
            v-for="(item, i) in activity"
            :key="i"
            :item="item"
        />
    </div>
</template>
